export default __webpack_public_path__ + "static/media/goat2.981b6306.png";